import { render, staticRenderFns } from "./AtendimentoLegadoEditForm.vue?vue&type=template&id=0c5b1e8e"
import script from "./AtendimentoLegadoEditForm.vue?vue&type=script&lang=js"
export * from "./AtendimentoLegadoEditForm.vue?vue&type=script&lang=js"
import style0 from "./AtendimentoLegadoEditForm.vue?vue&type=style&index=0&id=0c5b1e8e&prod&lang=scss"
import style1 from "./AtendimentoLegadoEditForm.vue?vue&type=style&index=1&id=0c5b1e8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports